<div class="container-fluid" [formGroup]="formData" jargonViewModeForm="notes:write">
  <!-- <div class="row">
    <app-history-view [title]="'Treatment'" [data]="noteData" [commentQty]="data.comments?.length"
                      [alias]="config.alias"
                      (reviewAction)="handleReviewAction($event)"></app-history-view>
  </div> -->
  <div class="row my-4 plan-row">
    <label class="form-label">Plan</label>
    <div class="col-12">
      <app-expandable-textarea  class="p-0"
                                [title]="'Plan'"
                                [placeholder]="'Start typing here...'"
                                formControlName="plan"
                                jargonLoadingState="builder-control"
                                (saveEvent)="saveNotes($event)">
      </app-expandable-textarea>
    </div>
  </div>
  <div class="row medication-row">
    <label class="form-label">Medications Administered During Consultation</label>

    <div class="col-12 mb-4">
      <ng-container formArrayName="medications">
        <div class="row g-2" *ngFor="let row of getRow('medications').controls; let i = index"
             [formGroupName]="i">
          <div class="col-2">
            <medprax-code-typeahead type="medicine" formControlName="nappi" jargonLoadingState="builder-control"
                                    placeholder="Name (start typing to search NAPPI)">
            </medprax-code-typeahead>
          </div>
          <div class="col-2">
            <select type="text" class="form-control" formControlName="type" jargonLoadingState="builder-control">
              <option hidden disabled [value]="null">Type</option>
              <option value="acute">Acute</option>
              <option value="chronic">Chronic</option>
            </select>
          </div>
          <div class="col-2">
            <div class="input-group">
              <input type="number" class="form-control" placeholder="Dosage" formControlName="quantity"
                     jargonLoadingState="builder-control">
              <select type="text" class="form-control" formControlName="unit" jargonLoadingState="builder-control">
                <option hidden disabled [value]="null">Units</option>
                <option *ngFor="let unit of dosageUnits" [value]="unit">{{ unit }}</option>
              </select>
            </div>
          </div>
          <div class="col-1">
            <select type="text" class="form-control" formControlName="frequency" jargonLoadingState="builder-control">
              <option hidden disabled [value]="null">Frequency</option>
              <option *ngFor="let freq of frequency" [value]="freq">{{ freq }}</option>
            </select>
          </div>
          <div class="col-2">
            <input type="text" class="form-control" placeholder="Time Period" formControlName="period"
                   jargonLoadingState="builder-control">
          </div>
          <div class="col-1">
            <select type="text" class="form-control" formControlName="route" jargonLoadingState="builder-control">
              <option hidden disabled [value]="null">Route of Delivery</option>
                <option *ngFor="let route of deliveryRoutes" [value]="route">{{ route }}</option>
            </select>
          </div>
          <div class="col-2">
            <div class="input-group mb-3">
              <input class="form-control" placeholder="Date" formControlName="date_of_script" ngbDatepicker
                     jargonLoadingState="builder-control"
                     #tsDate="ngbDatepicker" (click)="tsDate.toggle()">
              <ng-container *jargonViewMode="'notes:write'">
                <button class="btn btn-outline-secondary btn-sm"
                        type="button"
                        jargonLoadingState="builder-control"
                        (click)="removeRow('medications', i)">
                  <mat-icon>cancel</mat-icon>
                </button>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *jargonViewMode="'notes:write'">
        <div class="row">
          <div class="col-12">
            <button class="btn btn-outline-primary" (click)="addRow('medications')"
                    jargonLoadingState="builder-control">Add +</button>
          </div>
        </div>
      </ng-container>
    </div>

  </div>

  <div class="row procedure-row">
    <label class="form-label">Procedure(s)</label>

    <div class="col-12 mb-4">
      <ng-container formArrayName="procedures">
        <div class="row g-2" *ngFor="let row of getRow('procedures').controls; let i = index"
             [formGroupName]="i">
          <div class="col-4">
            <medprax-code-typeahead type="tariff" formControlName="code" jargonLoadingState="builder-control"
                                    placeholder="Start typing to search procedure codes..">
            </medprax-code-typeahead>
          </div>
          <div class="col-8">
            <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="Notes" formControlName="description"
                     jargonLoadingState="builder-control">
              <ng-container *jargonViewMode="'notes:write'">
                <button class="btn btn-outline-secondary btn-sm"
                        type="button"
                        jargonLoadingState="builder-control"
                        (click)="removeRow('procedures', i)">
                  <mat-icon>cancel</mat-icon>
                </button>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *jargonViewMode="'notes:write'">
        <div class="row">
          <div class="col-12">
            <button class="btn btn-outline-primary" (click)="addRow('procedures')"
                    jargonLoadingState="builder-control">Add +</button>
          </div>
        </div>
      </ng-container>
    </div>

  </div>
  <ng-container *jargonViewMode="'notes:write'">
    <div class="row script-row">
      <div class="col-12">
        <label class="form-label">Scripting</label>
      </div>
      <div class="col-12">
        <button *ngIf="!activeEscriptingProvider"
                class="btn btn-primary me-2"
                (click)="uploadAttachment()"
                jargonLoadingState="builder-control">
          Create Script
        </button>
        <button *ngIf="activeEscriptingProvider"
                class="btn btn-primary me-2"
                (click)="createScript()"
                jargonLoadingState="builder-control">
          Launch e-Scripting
        </button>
        <!-- <button class="btn btn-outline-primary" (click)="rxHistory()">Rx History</button> -->
      </div>
    </div>
  </ng-container>
</div>


<ng-template #preview let-data="data">
  <p>
    <ng-container *ngIf="data.plan">
      <strong>Treatment Plan: </strong>
      <p class="m-0">{{data.plan}}</p><br />
    </ng-container>
    <ng-container *ngIf="data.medications?.length">
      <strong>Medications: </strong>
      <span *ngFor="let c of data.medications; let i = index">
        ({{i + 1}}) [{{c.nappi.Code}}] {{c.nappi.Name || c.nappi.FullDescription || ''}}: {{c.type}} -
        {{c.quantity}}{{c.unit}} {{c.route}}
        {{c.frequency}} {{c.period}}
        [{{c.date_of_script}}]
      </span><br />
    </ng-container>
    <ng-container *ngIf="data.procedures?.length">
      <strong>Procedures: </strong>
      <span *ngFor="let v of data.procedures; let i = index">
        ({{i + 1}}) {{ v.code?.Code || v.code || '' }}{{ v.code?.Description ? ' ' + v.code?.Description : '' }}{{
        v.description ? ' - ' + v.description : '' }}
      </span><br />
    </ng-container>
  </p>
</ng-template>